import React from 'react';
import { Box, Stack, Tooltip } from '@mui/material';
import { theme } from '../../../../common/styles/theme';
import { LARGE_TOOLTIP_SLOT_PROPS } from '../../../../common/styles/tooltip';

export const RecordingDescription: React.FC<{
	text?: string | null;
	altText?: string | null; // the other language's version, shown under the text in the tooltip
	lines?: number; // clamp; the full text is in the tooltip
}> = ({ text, altText, lines = 2 }) => {
	if (!text) return null;
	return (
		<Tooltip
			title={
				<Stack
					sx={{
						p: theme.spacing(1),
					}}
				>
					<Box>{text}</Box>
					{altText && altText !== text &&
						<AltInfo>{altText}</AltInfo>
					}
				</Stack>
			}
			placement={'top'}
			enterDelay={500}
			enterNextDelay={500}
			disableInteractive
			slotProps={LARGE_TOOLTIP_SLOT_PROPS}
		>
			<Box
				sx={{
					display: '-webkit-box',
					WebkitLineClamp: lines,
					WebkitBoxOrient: 'vertical',
					overflow: 'hidden',
					minWidth: 0,
					lineHeight: 1.4,
					fontSize: theme.typography.subtitle1,
					color: theme.palette.grey[500],
				}}
			>
				{text}
			</Box>
		</Tooltip>
	);
};

// the other language's version in a tooltip, set apart from the current one
export const AltInfo: React.FC<{ children: React.ReactNode }> = ({ children }) => (
	<Box
		sx={{
			mt: 1,
			pt: 1,
			color: theme.palette.grey[300],
		}}
	>
		{children}
	</Box>
);
